import { useState } from 'react';
import IconArrow from '../../components/icons/IconArrow';
import IconEdit from '../../components/icons/IconEdit';
import IconDelete from '../../components/icons/IconDelete';
import { getNotificationBlockType } from '../../variables/notificationBlockTypes';
import { NOTIFICATION_BLOCK_EDITOR_REGISTRY } from './blockEditors';

// One block's card - mirrors TopicElementCard.jsx's toolbar chrome (type
// badge, edit toggle, move up/down, delete), but operates purely on the
// parent Builder's in-memory `blocks` array (no per-block backend id/REST
// call - the whole array is one JSON field, saved together by the parent's
// own Save button).
export default function NotificationBlockCard({ block, canMoveUp, canMoveDown, onMove, onSave, onDelete }) {
   const [isEditing, setIsEditing] = useState(false);
   const blockType = getNotificationBlockType(block.type);
   const registryEntry = NOTIFICATION_BLOCK_EDITOR_REGISTRY[block.type];
   if (!registryEntry) return null;
   const Editor = registryEntry.Editor;

   const handleSave = (changes) => {
      onSave({ ...block, ...changes });
      setIsEditing(false);
   };

   return (
      <div className='exercise-block-card' style={{ '--accent': blockType ? blockType.accent : '#7f7f7f' }}>
         <div className='exercise-block-card-toolbar'>
            <span className='exercise-block-card-type-label'>{blockType ? blockType.label : block.type}</span>
            <div className='exercise-block-card-actions'>
               <div className={'exercise-block-move-btn' + (!canMoveUp ? ' disabled' : '')} onClick={() => canMoveUp && onMove(-1)} title='Вгору'>
                  <IconArrow style={{ transform: 'rotate(-90deg)', height: 14, width: 14 }} />
               </div>
               <div className={'exercise-block-move-btn' + (!canMoveDown ? ' disabled' : '')} onClick={() => canMoveDown && onMove(1)} title='Вниз'>
                  <IconArrow style={{ transform: 'rotate(90deg)', height: 14, width: 14 }} />
               </div>
               <div className='exercise-block-edit-btn' onClick={() => setIsEditing((prev) => !prev)} title='Редагувати'>
                  <IconEdit style={{ fill: '#7ec2e8', width: 14, height: 14, margin: 0 }} />
               </div>
               <div className='exercise-block-delete-btn' onClick={onDelete} title='Видалити'>
                  <IconDelete style={{ width: 14, height: 14 }} />
               </div>
            </div>
         </div>
         <div className='exercise-block-card-body'>
            {isEditing ? (
               <Editor block={block} onSave={handleSave} onCancel={() => setIsEditing(false)} />
            ) : registryEntry.renderPreview(block)}
         </div>
      </div>
   );
}
